<template>
  <div class="servicos-list">
       <div class="os-tabs-controls">
            <ul class="nav nav-tabs smaller">
                <li class="nav-item">
                    <a href="" @click="tab = 'service'" class="nav-link active show" data-toggle="tab" data-target="#services">Serviços</a>
                </li>
                <li class="nav-item">
                    <a href="" @click="tab = 'about'" class="nav-link" data-toggle="tab" data-target="#about">Descrição</a>
                </li>
                <li class="nav-item">
                    <a href="" @click="tab = 'avaliacoes'" class="nav-link " data-toggle="tab" data-target="#avaliacoes">Avaliações</a>
                </li>
                <li class="nav-item">
                    <a href="" @click="tab = 'profissionais'" class="nav-link" data-toggle="tab" data-target="#profissionais">Profissionais</a>
                </li>
            </ul>
        </div>
        <div class="tab-content">
            <div class="tab-pane fade active show" id="services">
              <template v-if="tab === 'service'">
                <services-exame-tab v-if="isLaboratorio"></services-exame-tab>
                <services-tab v-else></services-tab>
              </template>
            </div>
            <div class="tab-pane fade" id="about" >
              <xp-tab v-if="tab === 'about'"></xp-tab>
            </div>
            <div class="tab-pane fade" id="avaliacoes" >
              <review-tab v-if="tab === 'avaliacoes'"></review-tab>
            </div>
            <div class="tab-pane fade" id="profissionais" >
              <profissional-tab v-if="tab === 'profissionais'"></profissional-tab>
            </div>
        </div>
  </div>

</template>
<script>
import ServicesTab from './ServicesTab'
import XpTab from './XpTab'
import ReviewTab from './ReviewsTab'
import ProfissionalTab from './ProfissionaisTab'
import ServicesExameTab from './ServicesExameTab'

export default {
  components: {
    ServicesTab,
    ServicesExameTab,
    XpTab,
    ReviewTab,
    ProfissionalTab
  },
  computed: {
    isLaboratorio () {
      return (this.$store.getters.redeSingle.tipoRede.indexOf('LABORATORIO') >= 0 ||
        this.$store.getters.redeSingle.tipoRede.indexOf('CLINICA DE IMAGEM') >= 0) && this.$route.query.exames
    }
  },
  data () {
    return {
      tab: 'service'
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/single-consultorio/TabClinica.vue